export default __webpack_public_path__ + "static/media/saqaya.4e54c4c6.png";